import { render, staticRenderFns } from "./InheritWrapper.vue?vue&type=template&id=2ed38275&scoped=true&lang=pug&"
import script from "./InheritWrapper.vue?vue&type=script&lang=js&"
export * from "./InheritWrapper.vue?vue&type=script&lang=js&"
import style0 from "./InheritWrapper.vue?vue&type=style&index=0&id=2ed38275&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed38275",
  null
  
)

export default component.exports